/** API origin without trailing slash (from REACT_APP_API_URL). */
export const API_ORIGIN = (process.env.REACT_APP_API_URL ?? 'http://localhost:5000').replace(
  /\/$/,
  ''
);

/** REST API base URL including /api prefix. */
export const API_BASE_URL = `${API_ORIGIN}/api`;
